var Banner = (function() {
    /*"use strict"; */ // Start of use strict
  var PLB_INTERNATIONAL_ID = 10;

  var init = function init() {

    var
      searchResults = util.id('results'),
      searchButton = util.id('search-button'),
      brandBanner = util.id('brand-banner'),
      brandDesc = util.id('brand-description'),
      brandDescImg = brandDesc.querySelector('img'),
      brandDescText = brandDesc.querySelector('p'),
      brandFilters = util.id('filters-container'),
      radioBrands = document.querySelectorAll('input[name="brand"]').toArray();
      searchResults.classList.add('is-hidden');
      radioBrands.forEach(function(item) {
        var _changeBrand = function _changeBrand() {
            window.location.href = item.getAttribute('data-href');
        };

        item.parentNode.addEventListener('click', _changeBrand);
      });
      window.onload=function(){
            for(var i = 0; i < radioBrands.length; i++)
            {
                if(radioBrands[i].checked)
                {
                    var
                        item = radioBrands[i],
                        banner = item.getAttribute('data-banner'),
                        logo = item.getAttribute('data-logo'),
                        desc = item.getAttribute('data-description');

                    $('label.brand').removeClass('is-active');

                    item.parentNode.classList.add('is-active');
                    searchResults.classList.add('is-hidden');
                    brandDesc.classList.remove('is-hidden');
                    brandFilters.classList.remove('is-hidden');

                    $('html, body').animate({
                        scrollTop: $('#filters-container').offset().top
                    }, 1000);

                    brandBanner.src = banner;
                    brandDescImg.src = logo;
                    brandDescText.innerHTML = desc;

                    reinitializeDropdown();
                    var dropdownCategories = util.id('category-'.concat(item.value));
                    dropdownCategories.removeAttribute('disabled');


                    dropdownCategories.parentNode.classList.remove('is-hidden');

                    $(dropdownCategories).customSelect();
                    $('.categories-container').removeClass('is-hidden');


                    //Ajust the document type dropdown based on the brand
                    initializeDocumentTypeDropdown(item.value);

                    //Show results if the use reclick on the current search banner
                    if(item.value == searchResults.getAttribute('value'))
                    {
                        searchResults.classList.remove('is-hidden');
                    }
                }
            }
        }
  };

  var reinitializeDropdown = function reinitializeDropdown() {
      var radioBrands = document.querySelectorAll('input[name="brand"]').toArray();
      radioBrands.forEach(function(item) {
           var dropdownCategories = util.id('category-'.concat(item.value));
           dropdownCategories.setAttribute("disabled", "true");
           dropdownCategories.parentNode.classList.add('is-hidden');
           //$(dropdownCategories).customSelect('destroy');
      });

      var dropdownDocumentType = util.id('product-type-initial');
      dropdownDocumentType.setAttribute("disabled", "true");
      dropdownDocumentType.parentNode.classList.add('is-hidden');
      //$(dropdownDocumentType).customSelect('destroy');

      var dropdownDocumentTypePlb = util.id('product-type-plb');
      dropdownDocumentTypePlb.setAttribute("disabled", "true");
      dropdownDocumentTypePlb.parentNode.classList.add('is-hidden');
      //$(dropdownDocumentTypePlb).customSelect('destroy');
  }

  var initializeDocumentTypeDropdown = function initializeDocumentTypeDropdown(id) {
      if(id == PLB_INTERNATIONAL_ID) {
          var dropdownDocumentTypePlb = util.id('product-type-plb');
          dropdownDocumentTypePlb.removeAttribute('disabled');
          dropdownDocumentTypePlb.parentNode.classList.remove('is-hidden');
          $(dropdownDocumentTypePlb).customSelect();
          $('.content-type-container').removeClass('is-hidden');
      }
      else {
          var dropdownDocumentType = util.id('product-type-initial');
          dropdownDocumentType.removeAttribute('disabled');
          dropdownDocumentType.parentNode.classList.remove('is-hidden');
          $(dropdownDocumentType).customSelect();
          $('.content-type-container').removeClass('is-hidden');
      }
  }


  return { init: init };
})();
